import Marquee from "react-fast-marquee";
import { MARQUEE_CODES } from "@/lib/data";

/** Slow editorial marquee — the clause codes drifting horizontally as texture. */
export default function CodeMarquee() {
  return (
    <div className="marquee-mask py-6 hairline-t hairline-b overflow-hidden">
      <Marquee speed={12} gradient={false} pauseOnHover autoFill={false}>
        {MARQUEE_CODES.map((c, i) => (
          <span
            key={c + i}
            className="font-mono text-[12px] md:text-[13px] tracking-[0.14em] text-white/40 mx-8"
          >
            {c}
            <span className="text-white/12 mx-6">·</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
